import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      isMobile: false,
      isTablet: false,
    };
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    resizeHandler() {
      this.isMobile = window.matchMedia('(max-width: 767px)').matches;
      this.isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches;
    },
  },
});
